const conditionDescription = {
  new: "Brand new, without signs of wear",
  excellent: "Very faint handling marks only",
  "very-good":
    "Few signs of wear and tear, with light scratches to the case and bracelet without any visible dents",
  good: "Visible signs of wear, scuffs or small dents",
  fair: "Significant age-related wear with obvious scratches and dents",
};

export default conditionDescription;
